"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=function(h,s,v){var _Mathround=Math.round,r=void 0,g=void 0,b=void 0,i=Math.floor(6*h),f=6*h-i,p=v*(1-s),q=v*(1-f*s),t=v*(1-(1-f)*s);switch(i%6){case 0:r=v,g=t,b=p;break;case 1:r=q,g=v,b=p;break;case 2:r=p,g=v,b=t;break;case 3:r=p,g=q,b=v;break;case 4:r=t,g=p,b=v;break;case 5:r=v,g=p,b=q;}return[_Mathround(255*r),_Mathround(255*g),_Mathround(255*b)]};


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-components/lib/__utils/helpers/hsvToRgb.js
// module id = 828
// module chunks = 0